import GrilleZonesKilometriquesFormController from './grille.zones.kilometriques.form.controller';

export default {
    template: require('./grille.zones.kilometriques.form.html'),
    controller: GrilleZonesKilometriquesFormController
};
